<template>
	<AutoComplete
		:suggestions="filteredInvoiceNum"
		@complete="searchInvoice($event)"
		:dropdown="true"
		field="INVOICE_NUM"
		placeholder="invoice From"
		forceSelection
	>
		<template #item="slotProp">
			{{ slotProp.item.INVOICE_NUM }}
		</template>
	</AutoComplete>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import AuthService from '../../../service/AuthService';
import paymentService from '../../../service/ReportPayment';

// eslint-disable-next-line no-undef
const filteredInvoiceNum = ref([]);
const invoiceFrom = ref([]);
// eslint-disable-next-line no-undef
const props = defineProps({
	company: { type: Object },
	supplier: { type: Object },
});

onMounted(() => {
	populateData();
});

const populateData = () => {
	AuthService.whoAmi().then(async () => {
		let payload;
		if (props.company !== null && props.supplier !== null) {
			payload = {
				org_id: props.company.value,
				suppVal: props.supplier.vendor_id,
				db_instance: props.company.db_instance,
			};
			console.log('payload ponumber from', payload);
			const data = await paymentService.getInvoiceNum(payload);
			invoiceFrom.value = data.data.data.data;
			console.log('isi data invoice to', invoiceFrom.value);
		} else if (props.company !== null) {
			payload = {
				org_id: props.company.value,
				db_instance: props.company.db_instance,
			};
			console.log('payload invoice from', payload);
			const data = await paymentService.getInvoiceNumComp(payload);
			console.log('isi data invoice to org_id', data);
			invoiceFrom.value = data.data.data.data;
			console.log('isi data invoice from', invoiceFrom.value);
		}
	});
};

const searchInvoice = (event) => {
	setTimeout(() => {
		if (!event.query.trim().length) {
			//
			//
			filteredInvoiceNum.value = [...invoiceFrom.value];
		} else {
			filteredInvoiceNum.value = invoiceFrom.value.filter((comp) => {
				return comp.INVOICE_NUM.toLowerCase().match(
					event.query.toLowerCase()
				);
			});
		}
	}, 250);
};
</script>

<style scoped></style>
